import { Variant } from '@mui/material/styles/createTypography'
import { DisplayNameDetails } from 'components/core/display-name-details'
import { appUserTypeToIntl } from 'components/pages/user/type'
import { AppUser, AppUserType } from 'pbts/c1/api/app/v1/app_user'
import React from 'react'
import { useIntl } from 'react-intl'

type AppUserAccountTypeProps = {
    appUser?: AppUser
    variant?: Variant
}

export const AppUserAccountType = ({ appUser, variant = 'body1' }: AppUserAccountTypeProps): React.ReactElement => {
    const intl = useIntl()

    return (
        <>
            {appUser?.appUserType === AppUserType.SERVICE_ACCOUNT && (
                <DisplayNameDetails
                    displayNameVariant={variant}
                    readOnly
                    margin={false}
                    displayName={appUserTypeToIntl(AppUserType.SERVICE_ACCOUNT, intl)}
                />
            )}
            {appUser?.appUserType === AppUserType.SYSTEM_ACCOUNT && (
                <DisplayNameDetails
                    displayNameVariant={variant}
                    readOnly
                    margin={false}
                    displayName={appUserTypeToIntl(AppUserType.SYSTEM_ACCOUNT, intl)}
                />
            )}
            {appUser?.appUserType === AppUserType.USER && (
                <DisplayNameDetails
                    displayNameVariant={variant}
                    readOnly
                    margin={false}
                    displayName={appUserTypeToIntl(AppUserType.USER, intl)}
                />
            )}
        </>
    )
}
